<template>
  <div class="content-wrapper container-xxl p-0">
    <div class="content-header row"></div>
    <div class="content-body">
      
      <div class="row">
        <div class="col-xl-4 col-lg-6 col-md-6" v-for="item in appid" :key="item">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between align-items-end mt-1">
                <div class="uom-heading">
                  <h4 class="fw-bolder">{{ item.platform }}</h4>
                  <b-button variant="warning" size="sm" @click="openEditModal(item)">Edit</b-button>
               <b-button variant="danger" class="ml-2" size="sm" @click="deleteAppId(item.id)">Delete</b-button>
                </div>
                
              </div>
              <app-collapse accordion>
                <app-collapse-item title="View Detail">
                  <div class="flex">
                    <p>
                      <span class="fw-bolder">App ID:</span>
                      <span class="fw-bolder"> {{ item.appId }}</span>
                    </p>
                    <p>
                      <span class="fw-bolder">App Secret:</span>
                      <span class="fw-bolder"> {{ item.appSecret }}</span>
                    </p>
                    <p>
                      <span class="fw-bolder">Page Name:</span>
                      <span class="fw-bolder"> {{ item.pageName }}</span>
                    </p>
                    <p>
                      <span class="fw-bolder">Page Id:</span>
                      <span class="fw-bolder"> {{ item.pageId }}</span>
                    </p>
                  </div>
                </app-collapse-item>
              </app-collapse>
            </div>
          </div>
        </div>
         
        <div class="col-xl-4 col-lg-6 col-md-6">
          <div class="card">
            <div class="row">
              <div class="col-sm-12">
                <div class="card-body text-sm-end text-center ps-sm-0">
                  <a
                    href="javascript:void(0)"
                    v-b-modal.modal-add-facebook
                    class="stretched-link text-nowrap add-new-uom"
                  >
                    <span class="btn btn-primary mb-3">Add Social Connection</span>
                  </a>
                  <p class="mb-0">Add Social connection, if it does not exist</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Add uom Modal -->
    <b-modal
      id="modal-add-facebook"
      ok-only
      ok-title="Accept"
      centered
      size="lg"
      title="Add New Social Connection"
      hide-footer="true"
    >
      <div class="modal-body px-5 pb-5">
        <div class="text-center mb-4">
          <h1 class="uom-title">Add Social Connection</h1>
        </div>
        <!-- Add uom form -->
        <validation-observer ref="Social"> 
        <form id="addUomForm" class="row" onsubmit="return false">
          <div class="col-12">
            <label class="form-label" for="pageId">Page Id</label>
            <input
              type="text"
              id="pageId"
              name="pageId"
              class="form-control"
              v-model="pageId"
              placeholder="Enter Page Id"
            />
          </div>
          <div class="col-12">
            <label class="form-label" for="pageName">Page Name</label>
            <input
              type="text"
              id="pageName"
              name="pageName"
              class="form-control"
              v-model="pageName"
              placeholder="Enter Page Name"
            />
          </div>
          <div class="col-12">
            <label class="form-label" for="userToken">User Token</label>
            <input
              type="text"
              id="userToken"
              name="userToken"
              class="form-control"
              v-model="userToken"
              placeholder="Enter User Token"
            />
          </div>
          <div class="col-12">
            <label class="form-label" for="appSecret">App Secret</label>
            <validation-provider rules="required" v-slot="{ errors }" name="appSecret" vid="appSecret">
            <input
              type="text"
              id="appSecret"
              name="appSecret"
              class="form-control"
              v-model="appSecret"
              placeholder="Enter App Secret"
            />
            <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
          </div>
          <div class="col-12">
            <label class="form-label" for="app_Id">App Id</label>
            <validation-provider rules="required" v-slot="{ errors }" name="app_Id" vid="app_Id">
            <input
              type="text"
              id="app_Id"
              name="app_Id"
              class="form-control"
              v-model="app_Id"
              placeholder="Enter App Id"
            />
            <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
          </div>

          <div class="col-12">
            <label class="form-label" for="platform">Platform</label>
            <validation-provider rules="required" v-slot="{ errors }" name="Platform" vid="platform">
            <b-form-select
              name="platform"
              class="form-control"
              v-model="platform"
              :options="platformOptions"
              placeholder="Select a Platform"
            />
            <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
          </div>

          <div class="col-12 text-center mt-2 d-flex justify-content-between">
            <b-button type="submit" class="btn btn-primary me-1" @click="addAppId">
              <b-spinner small v-if="loading" />Add Social Connection</b-button
            >
          </div>
        </form>
      </validation-observer>
        <!--/ Add uom form -->
      </div>
    </b-modal>

    <!-- Edit Social Connection Modal -->
    <b-modal id="modal-edit-facebook" centered size="lg" title="Edit Social Connection" hide-footer="true">
      <div class="modal-body px-5 pb-5">
        <div class="text-center mb-4">
          <h1 class="uom-title">Edit Social Connection</h1>
        </div>
        <validation-observer ref="EditSocial">
          <form id="editForm" class="row" @submit.prevent="updateAppId">
            <div class="col-12">
              <label class="form-label" for="editPageId">Page Id</label>
              <input type="text" id="editPageId" class="form-control" v-model="editPageId" />
            </div>
            <div class="col-12">
              <label class="form-label" for="editPageName">Page Name</label>
              <input type="text" id="editPageName" class="form-control" v-model="editPageName" />
            </div>
            <div class="col-12">
              <label class="form-label" for="editUserToken">User Token</label>
              <input type="text" id="editUserToken" class="form-control" v-model="editUserToken" />
            </div>
            <div class="col-12">
              <label class="form-label" for="editAppSecret">App Secret</label>
              <validation-provider rules="required" v-slot="{ errors }" name="appSecret" vid="appSecret">
              <input type="text" id="editAppSecret" class="form-control" v-model="editAppSecret" />
              <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
            <div class="col-12">
              <label class="form-label" for="editAppId">App Id</label>
              <validation-provider rules="required" v-slot="{ errors }" name="app_Id" vid="app_Id">
              <input type="text" id="editAppId" class="form-control" v-model="editAppId" />
              <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
            <div class="col-12">
              <label class="form-label" for="editPlatform">Platform</label>
              <validation-provider rules="required" v-slot="{ errors }" name="Platform" vid="platform">             
                <b-form-select class="form-control" disabled v-model="editPlatform" :options="platformOptions" />
              <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </div>
            <div class="col-12 text-center mt-2">
              <b-button type="submit" class="btn btn-success">Update Connection</b-button>
            </div>
          </form>
        </validation-observer>
      </div>
    </b-modal>

  </div>
</template>

<script>
import { BSpinner, BFormTextarea, BButton, BModal } from "bootstrap-vue";
import { BFormSelect} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue";
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue";
import Swal from "sweetalert2";
export default {
  name: "Unit of measure",
  components: {
    BSpinner,
    BFormSelect,
    BFormTextarea,
    BButton,
    BModal,
    AppCollapse,
    AppCollapseItem,
    ValidationProvider,
    ValidationObserver,
  },

  data() {
    return {
      ///edit
      editId: this.id,
      editPageId: "",
      editPageName: "",
      editUserToken: "",
      editAppSecret: "",
      editAppId: "",
      editPlatform: "",

      ///Add
      selectedItem: null,
      itemuoms: [],
      AddName: "",
      showSpinner: true,
      selectedUOM: [],

      ///Add
      pageId: "",
      pageName: "",
      userToken: "",
      appSecret: "",
      app_Id: "",
      platform: "",
    //   platformOptions: [
    //   { value: "facebook", text: "Facebook" },
    //   { value: "instagram", text: "Instagram" },
    //   { value: "twitter", text: "Twitter" },
    //   { value: "linkedin", text: "LinkedIn" },
    //   { value: "whatsapp", text: "WhatsApp" },
    // ],
    platformOptions: [
        { value: 'FACEBOOK', text: 'Facebook' },
        { value: 'INSTAGRAM', text: 'Instagram' },
        { value: 'LINKEDIN', text: 'LinkedIn' },
        { value: 'WHATSAPP', text: 'WhatsApp' },
      ]
    };
  },
  computed: {
    ...mapGetters("marketingModule", {
      appid: "appid",
      loading: "loading",
    }),
  },

  methods: {
    showDetails(item) {
      this.selectedItem = item;
    },
    formSubmitted() {
      //this.$router.push('/product/list/')
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Unit of measure Successfully Added",
          icon: "EditIcon",
          variant: "success",
        },
      }),
        this.$bvModal.hide("modal-add-facebook");
    },

    success() {
      this.$swal({
        title: "Connection added!",
        text: "You have successfully added a connection!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    resetForm() {
  this.pageId = "";
  this.pageName = "";
  this.userToken = "";
  this.appSecret = "";
  this.app_Id = "";
  this.platform = "";
  this.$refs.Social.reset(); // Reset form validation
},

    error(data) {
      let msg = null;
      if (data) msg = this.getErrorString(data.errors);
      this.$swal({
        title: "Error!",
        //text: msg ?? ' Failed!',
        html: msg ?? " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    successUpdate() {
      this.$swal({
        title: "Social connection added!",
        text: "You have successfully updated a UOM!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    errorUpdate(data) {
      this.$swal({
        title: "Error!",
        text: data.message,
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    getErrorString(errors) {
      let msg = null;
      if (errors) {
        msg = "<div>";
        msg = "<p>Cannot post your request due to the following errors:</p>";
        for (var prop in errors) {
          if (Object.prototype.hasOwnProperty.call(errors, prop) && prop !== "request") {
            msg += "<p>";
            msg += prop.replace("$.", "");
            msg += ": ";
            msg += errors[prop].toString().replace("$.", "");
            msg += "</p>";
          }
        }
        msg += "</div>";
        return msg;
      }
    },
    ...mapActions("marketingModule", ["getAppIdAction", "postAppIdAction", "putAppIdAction", "deleteAppIdAction"]),

    openEditModal(item) {
      this.id = item.id;
      this.editPageId = item.pageId;
      this.editPageName = item.pageName;
      this.editUserToken = item.userToken;
      this.editAppSecret = item.appSecret;
      this.editAppId = item.appId;
      this.editPlatform = item.platform;
      this.$bvModal.show("modal-edit-facebook");
    },

    successEdit() {
      this.$swal({
        title: "Social connection added!",
        text: "You have successfully saved the connection!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    errorEdit() {
      this.$swal({
        title: "Error!",
        text: " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    sendInfo(info) {
      this.selectedUOM = info;
      this.permissions.forEach((permission) => {
        if (info.permissions.includes(permission.value)) {
          this.selectedPermissions.push(permission.value);
        }
      });
    },

    // Update Social Connection
    updateAppId() {
  this.$refs.EditSocial.validate().then((success) => {
    if (success) {
      this.$swal.fire({
        title: "Are you sure?",
        text: "Do you want to update this social connection?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, update it!",
        cancelButtonText: "No, cancel!",
        customClass: {
         confirmButton: 'swal-confirm-btn',  // ✅ Apply custom spacing
        cancelButton: 'swal-cancel-btn'
        },
      }).then((result) => {
        if (result.isConfirmed) {
          // Show loader
          this.$swal.fire({
            title: "Updating...",
            text: "Please wait while the update is in progress.",
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => {
              this.$swal.showLoading();
            },
          });

          const payload = {
            id: this.id,
            pageId: this.editPageId,
            pageName: this.editPageName,
            userToken: this.editUserToken,
            appSecret: this.editAppSecret,
            appId: this.editAppId,
            platform: this.editPlatform,
          };
            console.log("update",payload);
          this.putAppIdAction(payload)
            .then(() => {
              this.$bvModal.hide("modal-edit-facebook");
              this.$swal.fire({
                title: "Updated!",
                text: "Social connection updated successfully!",
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                buttonsStyling: false,
              });
              this.getAppIdAction(); // Refresh data
            })
            .catch((error) => {
              console.error("Update failed:", error.response ? error.response.data : error.message);
              this.$swal({
                title: "Error!",
                text: "Failed to update social connection!",
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-danger",
                },
              });
            });
        }
      });
    }
  });
},


    //delete Social Connection
    deleteAppId(itemId) {
  console.log("Delete button clicked for ID:", itemId);
  
  this.$swal({
    title: "Are you sure?",
    text: "This action cannot be undone!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Yes, delete it!",
    cancelButtonText: "No, cancel!",
    customClass: {
      confirmButton: 'swal-confirm-btn',  // ✅ Apply custom spacing
      cancelButton: 'swal-cancel-btn'
    },
  }).then((result) => {
    if (result.isConfirmed) {
      
      // Show SweetAlert2 Loader
      this.$swal({
        title: "Deleting...",
        text: "Please wait while the social connection is being deleted.",
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });

      // Call delete action
      this.deleteAppIdAction(itemId)
        .then(() => {
          this.$swal({
            title: "Deleted!",
            text: "Social connection has been deleted.",
            icon: "success",
            customClass: {
              confirmButton: "btn btn-primary",
            },
             buttonsStyling: false,
          });
          this.getAppIdAction(); // Refresh the list after deletion
        })
        .catch((error) => {
          console.error("Delete API request failed:", error.response ? error.response.data : error.message);
          this.$swal({
            title: "Error!",
            text: "Failed to delete social connection!",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-danger",
            },
          });
        });
    }
  });
},


    updateUOM() {
      // let payload = {
      //     itemuomId: this.selectedUOM.id,
      //     name: this.selectedUOM.name
      // };
      let payload = this.selectedUOM;

      this.updateItemUOMAction(payload)
        .then(() => {
          this.successEdit();
          this.$bvModal.hide("modal-edit");
        })
        .catch(() => {
          this.errorEdit();
          this.$bvModal.hide("modal-edit");
        });
    },

    addAppId() {
      this.$refs.Social.validate().then((success) => {
        if (success) {
      let payload = {
        pageId: this.pageId,
        pageName: this.pageName,
        userToken: this.userToken,
        appSecret: this.appSecret,
        app_Id: this.app_Id,
        platform: this.platform,
      };
      this.postAppIdAction(payload)
        .then((response) => {
          this.success();
          this.getAppIdAction();
          this.$bvModal.hide("modal-add-facebook");
          this.resetForm()
        })
        .catch((response) => {
          this.error(response);
          this.getAppIdAction();
          this.$bvModal.hide("modal-add-facebook");
          this.resetForm()
        });
      }
      })
    },
  },

  async mounted() {
  this.$swal({
    title: "Loading...",
    text: "Fetching social connections, please wait...",
    allowOutsideClick: false,
    allowEscapeKey: false,
    didOpen: () => {
      this.$swal.showLoading();
    },
  });

  try {
    const response = await this.getAppIdAction(); // Fetch data
    console.log("response", response);
    this.$swal.close(); 

    
  } catch (error) {
    this.$swal({
      title: "Error!",
      text: "Failed to fetch social connections.",
      icon: "error",
      customClass: {
        confirmButton: "btn btn-danger",
      },
    });
  }
},


};
</script>

<style>
/* ✅ Add spacing between Swal buttons */
.swal-confirm-btn {
  margin-right: 10px !important; /* Ensure spacing between confirm and cancel */
}
.swal-cancel-btn {
  margin-left: 10px !important; /* Ensure spacing between confirm and cancel */
}

</style>